<template>
  <div class="main-wrapper">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style lang="scss">
#app {
  /* font-family: Helvetica, Arial, sans-serif;*/
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: $bluegrey;
  color: $darkbrown;
  /* margin-top: 60px; */
  margin: 0;
  padding-bottom: 56px;
  @include Roboto();
  &:after {
    content: "";
    position: fixed;
    top: 0px;
    bottom: 0px;
    right: 0px;
    left: 0px;
    height: 100%;
    width: 100%;
    z-index: -1;
    background: $beige;
    /* background: $beige;*/
  }
  .main-wrapper {
    max-width: 960px;
    margin: auto;
    width: 90%;
    @media only screen and (max-device-width: 768px) {
      max-width: 560px;
    }
  }
}
</style>
